import React from 'react'
import styles from './Footer.module.css'
import arrowRight from "../../assets/icons/arrowRight.png"
import emailLogo from "../../assets/icons/sms.png"
import addressIcon from "../../assets/icons/location.png"
import xLogo from "../../assets/icons/twitterX.png"
import fnxWhiteLogo from "../../assets/image/img-logo.svg"

function Footer() {
    return (
        <div className={styles.footerContainer}>
            <div className={styles.footerAddressSupportConatiner}>
                <div className={styles.footerAdSLeft}>
                    <div className={styles.footerAdSLeftEmail}>
                        <img src={emailLogo} alt="Email Icon" />
                        <a href="mailto:support@nxt-fintech.com">support@nxt-fintech.com</a>
                    </div>
                    <div className={styles.footerAdSLeftAddress}>
                        <img src={addressIcon} alt="Location Icon" />
                        <p> 4th Floor Ver. Building, 2-12-1 <br /> Jingumae, Shibuya-ku, Tokyo, Japan</p>
                    </div>
                    <button>
                        <img src={xLogo} alt="Arrow Right" />
                        <a target='_blank' href="https://x.com/nxt_fintech"> Follow On X</a>
                    </button>
                </div>
                <div className={styles.footerAdSRight}>
                    <h2 className={styles.desktopH1}>Ready to Secure Your <br /> Delegations? Get in Touch with <br /> Our Experts Today!</h2>
                    <h2 className={styles.mobileH1}>Ready to Secure Your Delegations? Get <br /> in Touch with Our Experts Today!</h2>
                    <button 
                    onClick={()=> window.open("https://form.run/@soichiro-tokuriki-3s4uP4gsFEheaSFe6Jcq","_blank")}
                    >
                        Contact Us
                        <img src={arrowRight} alt="Arrow Right" />
                    </button>
                </div>
            </div>
            <div className={styles.footerEndSection}>
                <div className={styles.profTitle}>
                    <div className={styles.profTitleLeftLine}></div>
                    <div className={styles.profTitleText}>
                        <img src={fnxWhiteLogo} alt="" />
                    </div>
                    <div className={styles.profTitleRightLine}></div>
                </div>
                <p>©2024 Next Finance Tech</p>
            </div>
        </div>
    )
}

export default Footer